import { Injectable } from '@angular/core';
import { OccPromoCouponResponse } from '@core/const';
import { OccPromoCouponService } from '@core/data-access';
import { SnackTheme } from '@main/snackbar/const';
import { SnackbarFacade } from '@main/snackbar/data-access';
import { Observable, throwError } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PromoCouponService {
  constructor(
    private snackbarFacade: SnackbarFacade,
    private occPromoCouponService: OccPromoCouponService,
  ) {}

  requestCoupon(phoneNumber: string, couponCode: string): Observable<OccPromoCouponResponse> {
    return this.occPromoCouponService.sendRequest(phoneNumber, couponCode).pipe(
      take(1),
      catchError((error: unknown) => {
        this.snackbarFacade.setSnack({
          title: 'Ошибка создания промокода',
          text: 'Свяжитесь с колл-центром или оставьте свой номер в форме обратной связи и мы вам перезвоним',
          theme: SnackTheme.Yellow,
        });

        return throwError(() => error);
      }),
    );
  }
}
